import { FeatureEnabledV2, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Mixins } from 'vue-property-decorator';
import { Feature } from '@gig/magic-messages';
import { SIGN_UP_NAMESPACE } from '../../../store/modules/sign-up/sign-up.constants.js';
import { VerificationTypeId } from '@gig/magic-sdk/dist/adapter/signup/registrationTypes';
import '../../../store/modules/sign-up/sign-up.store.js';
import { store } from '../../../store/index.js';
import { namespace } from 'vuex-class';
import Component from 'vue-class-component';
import { minLength, required } from 'vuelidate/lib/validators';

var signUpModule = namespace(SIGN_UP_NAMESPACE);
/**
 * Displays 3rd step of registration process, depending on
 * country/verification types available. Can display
 * SMS code based or Email verification.
 */
var VerifyPromptComponent = /** @class */ (function (_super) {
    __extends(VerifyPromptComponent, _super);
    function VerifyPromptComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * If it's true it if the email is found in the email clients config
         * it will display a CTA to open the client in step 3.
         */
        _this.verificationEmailClients = false;
        return _this;
    }
    Object.defineProperty(VerifyPromptComponent.prototype, "isSmsVerification", {
        get: function () {
            return (this.verificationType === VerificationTypeId.SMS ||
                this.verificationType === VerificationTypeId.SMS_AND_EMAIL);
        },
        enumerable: false,
        configurable: true
    });
    VerifyPromptComponent.prototype.created = function () {
        this.signupComplete();
    };
    VerifyPromptComponent.prototype.signupComplete = function () {
        return this.authModel;
    };
    __decorate([
        Prop({ type: Number, required: true, default: 3 }),
        __metadata("design:type", Number)
    ], VerifyPromptComponent.prototype, "steps", void 0);
    __decorate([
        signUpModule.Getter('authModel'),
        __metadata("design:type", void 0)
    ], VerifyPromptComponent.prototype, "authModel", void 0);
    __decorate([
        signUpModule.Getter('verificationType'),
        __metadata("design:type", void 0)
    ], VerifyPromptComponent.prototype, "verificationType", void 0);
    __decorate([
        FeatureEnabledV2({ slug: Feature.VERIFICATION_EMAIL_CLIENTS }),
        __metadata("design:type", Boolean)
    ], VerifyPromptComponent.prototype, "verificationEmailClients", void 0);
    __decorate([
        Emit('signup-complete'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VerifyPromptComponent.prototype, "signupComplete", null);
    VerifyPromptComponent = __decorate([
        Component({
            name: 'corex-verify-prompt',
            store: store,
            validations: {
                code: {
                    minLength: minLength(4),
                    required: required,
                },
            },
        })
    ], VerifyPromptComponent);
    return VerifyPromptComponent;
}(Mixins(MagicConfigMixin)));

export default VerifyPromptComponent;
